<template>
<div id="toolbar">
  <!-- 字体选择器 -->
  <el-popover
    placement="bottom-start"
    trigger="click"
    v-model="fontSizeData.isShow">
    <button type="button" class="custom-btn w-100" slot="reference">
      <i class="editor-sprite editor-icon-1"></i>
      <i class="inline">字体大小</i>
    </button>
    <div class="fontsize-popver">
      <button
        type="button"
        v-for="item of fontSizeData.list"
        :class="{ selected: item === fontSizeData.size }"
        @click="setFontSize(item)"
        :key="item"
      >
        <span :style="{ fontSize: item }">{{ item }}</span>
      </button>
    </div>
  </el-popover>
  <button type="button" class="custom-btn w-50" @click.stop="setColor('#ff0000')">
    <span class="bg-red">红</span>
  </button>
  <button type="button" class="custom-btn w-50" @click.stop="setColor('#0000ff')">
    <span class="bg-blue">蓝</span>
  </button>
  <button type="button" class="custom-btn w-50" @click.stop="setColor('#000000')">
    <span class="bg-black">黑</span>
  </button>
  <!-- 颜色选择器 -->
  <el-popover
    placement="bottom-start"
    trigger="click"
    v-model="colorData.isShow"
    width="220">
    <button type="button" class="custom-btn w-80" slot="reference">
      <i class="editor-sprite editor-icon-2"></i>
      <i class="inline">更多</i>
    </button>
    <div class="color-popver">
      <button
        type="button"
        v-for="item of colorData.list"
        :class="{ selected: colorData.color === item }"
        :style="{ backgroundColor: item }"
        @click="setColor(item)"
        :key="item">
      </button>
    </div>
  </el-popover>
  <!-- 加粗 -->
  <button type="button" class="custom-btn w-80" :value="isBold" @click="bold">
    <span class="bg-gray" style="margin-right: 7px;">B</span>加粗
  </button>
  <!-- 链接 -->
  <el-popover
    placement="bottom-start"
    trigger="click"
    v-model="linkData.isShow"
    width="440">
    <button type="button" class="custom-btn w-40" slot="reference">
      <i class="editor-sprite editor-icon-3"></i>
    </button>
    <!-- <div class="link-popver"> -->
      <el-row>
        <el-col :span="19">
          <el-input placeholder="请输入内容" v-model="linkData.url">
            <template slot="prepend">链接地址</template>
          </el-input>
        </el-col>
        <el-col :span="4" :offset="1">
          <el-button @click="link">确定</el-button>
        </el-col>
      </el-row>
    <!-- </div> -->
  </el-popover>
  <!-- swf音乐 -->
  <el-popover
    placement="bottom-start"
    trigger="click"
    v-model="flashData.isShow"
    >
    <button type="button" class="custom-btn w-40" slot="reference">
      <i class="editor-sprite editor-icon-4"></i>
    </button>
    <el-row style="margin-bottom: 10px;">
      <el-col :span="24">
        <el-input placeholder="请输入地址" v-model="flashData.url">
          <template slot="prepend">SWF地址</template>
        </el-input>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="10">
        <el-input placeholder="请输入宽度" v-model="flashData.width">
          <template slot="prepend">宽</template>
        </el-input>
      </el-col>
      <el-col :span="10">
        <el-input placeholder="请输入高度" v-model="flashData.height">
          <template slot="prepend">高</template>
        </el-input>
      </el-col>
      <el-col :span="4">
        <el-button @click="flash">确定</el-button>
      </el-col>
    </el-row>
  </el-popover>
  <!-- 表情 -->
  <el-popover
    placement="bottom-start"
    trigger="click"
    width="400">
    <button type="button" class="custom-btn w-40" slot="reference">
      <i class="editor-sprite editor-icon-5"></i>
    </button>
    <div class="expression-popver">
      <y-expression @select="expression" />
    </div>
  </el-popover>
  <!-- 全选 -->
  <button type="button" class="custom-btn w-40" title="全选" @click="selectAll">
    <i class="editor-sprite editor-icon-6"></i>
  </button>
  <!-- 图片上传 -->
  <button type="button" class="custom-btn w-40" @click="image">
    <i class="editor-sprite editor-icon-7"></i>
  </button>
  <!-- 常用观点 -->
  <el-popover v-if="!disableNormalView"
    placement="bottom-start"
    trigger="click"
    width="400">
    <button type="button" class="custom-btn last" slot="reference">常用观点</button>
    <ul class="normal-view-popver">
      <li v-for="item of normalViewList" @click="handleNormalView(item.content)" :key="item.id">{{ item.title }}</li>
    </ul>
  </el-popover>
</div>
</template>

<script>
import { mapState } from 'vuex'
import YExpression from './Expression'

export default {
  name: 'toolbar',
  props: {
    module: {
      type: Object
    }
  },
  data () {
    return {
      isBold: false,
      fontSizeData: {
        isShow: false,
        size: '16px',
        list: ['14px', '16px', '18px', '20px', '26px']
      },
      colorData: {
        isShow: false,
        color: null,
        list: ['#000000', '#ff6699', '#cd0000', '#7c1515', '#ff6600', '#009900', '#cc33cc', '#6600cd', '#333333']
      },
      flashData: {
        url: '',
        width: null,
        height: null,
        isShow: false
      },
      linkData: {
        url: '',
        isShow: false
      }
    }
  },
  methods: {
    setFontSize (size) {
      this.$parent.size = this.fontSizeData.size = size
      this.editor.format('size', size)
      this.fontSizeData.isShow = false
    },
    setColor (color) {
      this.$parent.color = this.colorData.color = color
      this.editor.format('color', color)
      this.colorData.isShow = false
    },
    // 加粗
    bold (e) {
      this.isBold = !e.currentTarget.value
      this.editor.format('bold', this.isBold)
    },
    // 全选
    selectAll () {
      this.editor.setSelection(0, this.editor.getLength())
    },
    // 插入链接
    link () {
      let range = this.editor.getSelection(true)
      if (range.length > 0) {
        this.editor.format('link', this.linkData.url, 'user')
      } else {
        this.editor.insertText(range.index, this.linkData.url, { 'link': this.linkData.url }, 'user')
        this.editor.setSelection(range.index + this.linkData.url.length, 'silent');
      }
      this.linkData.isShow = false
    },
    // 插入flash
    flash () {
      let range = this.editor.getSelection(true)
      let index = range ? range.index : 0
      this.editor.insertEmbed(index, 'swf', {
        value: this.flashData.url,
        width: this.flashData.width,
        height: this.flashData.height,
      }, 'user');
      this.editor.setSelection(index + 1, 'silent');
      this.flashData.isShow = false
    },
    // 插入图片
    image () {
      let fileInput = this.$el.querySelector('input.ql-image[type=file]');
      if (fileInput == null) {
        fileInput = document.createElement('input');
        fileInput.setAttribute('type', 'file');
        fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
        fileInput.classList.add('ql-image');
        fileInput.addEventListener('change', () => {
          if (fileInput.files != null && fileInput.files[0] != null) {
            let reader = new FileReader();
            reader.onload = (e) => {
              this.$axios.postFile('/Common/UploadImage', { type: 4 }, fileInput.files[0]).then(resp => {
                if (resp && resp.url) {
                  let range = this.editor.getSelection(true)
              		let index = range ? range.index : 0
              		this.editor.insertEmbed(index, 'image', resp.url, 'user');
              		this.editor.setSelection(index + 1, 'silent');
                  fileInput.value = ""
                }
              }).catch(err => {
                this.$notify({
                  type: 'warning',
                  title: err.message,
                  message: '文件大小请勿超过1M'
                })
              })
            }
            reader.readAsDataURL(fileInput.files[0]);
          }
        });
        this.$el.appendChild(fileInput);
      }
      fileInput.click();
    },
    // 插入表情
    expression (v) {
      if (v) {
        let range = this.editor.getSelection(true)
        let index = range ? range.index : 0
        this.editor.insertEmbed(index, 'image', v.src, 'user')
        this.editor.setSelection(index + 1, 'silent')
      }
    },
    // 常用观点
    handleNormalView (content) {
      let range = this.editor.getSelection(true)
      let index = range ? range.index : 0
      let delta = this.editor.clipboard.dangerouslyPasteHTML(index, content, 'user')
      if (!delta.ops) {
        return
      }
      for (let item of delta.ops) {
        if (item.insert === undefined) {
          continue
        }
        if (typeof item.insert === 'string') {
          index = index + item.insert.length
        } else {
          index = index + 1
        }
      }
      this.editor.setSelection(index, 'silent')
    }
  },
  computed: {
    editor () {
      return this.$parent.quill
    },
    disableNormalView () {
      return this.module && this.module.normalView === false
    },
    ...mapState({
      normalViewList: state => state.user.normalView
    })
  },
  components: {
    YExpression
  }
}
</script>

<style lang="less" scoped>
.editor-sprite {
  background-image: url(~assets/editor/editor-icons.png); width: 26px; height: 26px; float: left;
}
.editor-icon-1 {
  background-position: 0 0;
}
.editor-icon-2 {
  background-position: -26px 0;
}
.editor-icon-3 {
  background-position: -52px 0;
}
.editor-icon-4 {
  background-position: -78px 0;
}
.editor-icon-5 {
  background-position: -104px 0;
}
.editor-icon-6 {
  background-position: -130px 0;
}
.editor-icon-7 {
  background-position: -156px 0;
}
.ql-snow.ql-toolbar {
  padding: 0; background-color: #f0f0ee;
  .custom-btn {
    height: 40px; border-right: 1px solid #c5c5c5; padding-left: 6px; text-align: center;
    span {
      display: inline-block; width: 26px; border-radius: 50%; font-size: 14px; line-height: 26px; color: #fff;
    }
    i.inline { margin-top: 4px; }
    &.last { border-right: 0; width: 108px; }
  }
}
// 字体选择器
.fontsize-popver button {
  display: block; padding: 5px 10px; background: #fff; border: none; width: 100%; text-align: left;
  &:hover,
  &.selected { background: #ccc }
}
// 颜色选择器样式
.color-popver button {
  width: 16px; height: 16px; border: 1px solid transparent; display: inline-block; margin: 2px;
  &:hover,
  &.selected { border-color: #000; }
}
// 常用观点样式
.normal-view-popver {
  max-height: 100px; overflow-y: auto;
  > li { height: 25px; line-height: 25px; border-bottom: 1px dashed #ccc; overflow: hidden; cursor: pointer;}
}
.bg-red { background: #f20500!important; }
.bg-blue { background: #1b6dd9!important; }
.bg-black { background: #000!important; }
.bg-gray { background: #666!important; }
.w-100 { width: 100px!important; }
.w-80 { width: 80px!important; }
.w-50 { width: 50px!important; }
.w-40 { width: 40px!important; }
</style>
